<script setup>
  import {computed} from "vue";

  import LayoutFooter from "@components/Layout/Components/Footer.vue";
  import LayoutGuestHeader from "@components/Layout/Components/GuestHeader.vue";
  import {Head as InertiaHead} from "@inertiajs/vue3";
  import {MedButton} from "@pharma4u/medicheck-components";

  defineOptions({
    name: "PagesErrorShow",
  });

  const props = defineProps({
    code: {
      type: Number,
      default: 0,
    },
    message: {
      type: String,
      default: "",
    },
    isLoggedIn: {
      type: Boolean,
      default: false,
    },
  });

  const title = computed(() => {
    return {
      503: "Dienst nicht verfügbar",
      500: "Serverfehler",
      429: "Zu viele Anfragen",
      419: "Sitzung abgelaufen",
      404: "Seite nicht gefunden",
      403: "Verboten",
      400: "Bad Request",
      401: "Unautorisiert",
    }[props.code];
  });

  const description = computed(() => {
    return {
      503: "Entschuldigung, wir führen gerade Wartungsarbeiten durch. Bitte versuchen Sie es später erneut.",
      500: "Hoppla, auf unseren Servern ist etwas schiefgelaufen.",
      429: "Entschuldigung, Sie haben zu viele Anfragen gesendet. Bitte versuchen Sie es später erneut.",
      419: "Entschuldigung, die Sitzung ist abgelaufen. Bitte melden Sie sich erneut an.",
      404: "Entschuldigung, die von Ihnen gesuchte Seite konnte nicht gefunden werden.",
      403: "Entschuldigung, Sie sind nicht berechtigt, auf diese Seite zuzugreifen.",
      400: "Entschuldigung, die Anfrage konnte nicht verarbeitet werden.",
      401: "Entschuldigung, Sie sind nicht autorisiert, diese Seite zu sehen.",
    }[props.code];
  });

  const isDevelopment = computed(() => import.meta.env.DEV);

  const getBack = () => {
    globalThis.history.back();
  };
</script>

<template>
  <div class="flex min-h-screen flex-col">
    <InertiaHead :title="title" class="print:hidden" />

    <layout-guest-header />

    <main id="container" class="grow px-2 py-4 md:px-4 print:hidden">
      <div class="flex h-full flex-col items-center justify-center">
        <div class="text-center text-4xl" :data-test="getTestId('code')">
          {{ code }}
        </div>

        <div class="text-center text-xl" :data-test="getTestId('title')">
          {{ title }}
        </div>

        <div class="text-md text-center" :data-test="getTestId('description')">
          {{ description }}

          <div v-if="isDevelopment" class="rounded bg-mcred-100 p-1" :data-test="getTestId('dev-message')">
            Message: {{ message }}
          </div>
        </div>

        <div class="mt-3 flex space-x-3">
          <template v-if="isLoggedIn">
            <MedButton
              as="inertia"
              variant="primary"
              :href="$route('dashboard.index')"
              :data-test="getTestId('dashboard-button')"
            >
              zum Dashboard
            </MedButton>
          </template>

          <template v-else>
            <MedButton as="inertia" variant="primary" :href="$route('login')" :data-test="getTestId('login-button')">
              zum Login
            </MedButton>
          </template>

          <MedButton :data-test="getTestId('back-button')" @click="getBack">Zurück</MedButton>
        </div>
      </div>
    </main>

    <layout-footer class="print:hidden" />
  </div>
</template>
